import { useState, useEffect } from "react";
import { REQUEST_STATUS, RequestStatus } from "../../../shared/consts";
import { sendDimensionRequest } from "../word-suggestion-service";
import { Dimension } from "../types";

type FetchDimensionsResult = {
  dimensions: Dimension[];
  dimensionRequestStatus: RequestStatus;
};

export const useFetchDimensions = (
  open: boolean,
  functionKey: string
): FetchDimensionsResult => {
  const [dimensions, setDimensions] = useState<Dimension[]>([]);
  const [dimensionRequestStatus, setDimensionRequestStatus] =
    useState<RequestStatus>(REQUEST_STATUS.LOADING);
  useEffect(() => {
    if (open) {
      const fetchDimensions = async () => {
        try {
          const response = await sendDimensionRequest(functionKey);
          if (response.ok) {
            const data = JSON.parse(await response.text());
            setDimensions(data.dimensions || []);
            setDimensionRequestStatus(REQUEST_STATUS.SUCCESS);
          } else {
            setDimensionRequestStatus(REQUEST_STATUS.FAILURE);
          }
        } catch (err) {
          setDimensionRequestStatus(REQUEST_STATUS.FAILURE);
        }
      };
      fetchDimensions();
    } else {
      setDimensions([]);
      setDimensionRequestStatus(REQUEST_STATUS.LOADING);
    }
  }, [open]);
  return {
    dimensions,
    dimensionRequestStatus,
  };
};
